module.exports = __webpack_public_path__ + "img/127541261450947_image.jpg";